const generateForm06 = [
  {
    label: "คำนำหน้า (ภาษาอังกฤษ)", // i18n-ignore (translated at render site)
    name: "title_en",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ชื่อ (ภาษาอังกฤษ)", // i18n-ignore (translated at render site)
    name: "first_name_en",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "นามสกุล (ภาษาอังกฤษ)", // i18n-ignore (translated at render site)
    name: "last_name_en",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ฉายา (ภาษาอังกฤษ)", // i18n-ignore (translated at render site)
    name: "buddhist_name_en",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ข้อมูลการไปปฏิบัติงาน", // i18n-ignore (translated at render site)
    name: "",
    placeholder: "",
    type: "header",
    typeForm: "",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },

  {
    label: "หน่วยงานที่ไปปฏิบัติงานให้", // i18n-ignore (translated at render site)
    name: "organization",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 12, lg: 9 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },
  {
    label: "ประเทศ", // i18n-ignore (translated at render site)
    name: "country",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },
  {
    label: "ตำแหน่งที่จะไปปฏิบัติงาน", // i18n-ignore (translated at render site)
    name: "position",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 4 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },
  {
    label: "ระดับ", // i18n-ignore (translated at render site)
    name: "level",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 2 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },
  {
    label: "หน้าที่ที่จะไปปฏิบัติงาน (โดยย่อ)", // i18n-ignore (translated at render site)
    name: "duties_performed",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 6 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },

  {
    label: "การติดต่อไปปฏิบัติงาน", // i18n-ignore (translated at render site)
    name: "",
    placeholder: "",
    type: "header",
    typeForm: "",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },
  {
    label: "",
    name: "contact_name",
    placeholder: "placeholder",
    type: "radio-input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    radioName: "contact_work",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "contact_work",
  },

  {
    label: "ระยะเวลาที่จะขอไปปฏิบัติงาน", // i18n-ignore (translated at render site)
    name: "",
    placeholder: "",
    type: "header",
    typeForm: "",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },
  {
    label: "จำนวนปี", // i18n-ignore (translated at render site)
    name: "year_amount",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "period_time_work",
  },
  {
    label: "จำนวนเดือน", // i18n-ignore (translated at render site)
    name: "month_amount",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "period_time_work",
  },
  {
    label: "จำนวนวัน", // i18n-ignore (translated at render site)
    name: "day_amount",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "period_time_work",
  },
  {
    label: "กำหนดออกเดินทางประมาณ", // i18n-ignore (translated at render site)
    name: "departure_date",
    placeholder: "",
    type: "date",
    typeForm: "date",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "period_time_work",
  },

  {
    label: "ข้อมูลค่าตอบแทน", // i18n-ignore (translated at render site)
    name: "",
    placeholder: "",
    type: "header",
    typeForm: "",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },
  {
    label: "ค่าตอบแทนที่ได้รับ (บาท)", // i18n-ignore (translated at render site)
    name: "thb",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "remuneration",
  },
  {
    label: "เงินเดือน อัตราเงินเดือน/ปีละ", // i18n-ignore (translated at render site)
    name: "saraly_rate",
    placeholder: "",
    type: "checkbox-input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    radioName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "remuneration_info",
  },
  {
    label: "ค่าที่พัก", // i18n-ignore (translated at render site)
    name: "accommodation_costs",
    placeholder: "",
    type: "checkbox-input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    radioName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "remuneration_info",
  },
  {
    label: "ค่าพาหนะในการเดินทาง", // i18n-ignore (translated at render site)
    name: "transportation_costs",
    placeholder: "",
    type: "checkbox-input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    radioName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "remuneration_info",
  },
  {
    label: "อื่นๆ", // i18n-ignore (translated at render site)
    name: "other",
    placeholder: "",
    type: "checkbox-input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    radioName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "remuneration_info",
  },
];

export default generateForm06;
